<template>
    <div>

        <main role="main">

            <div class="container-fluid">


                <div class="row mt-2 mb-2">
                    <div class="col-md-12">

                        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

                        <div class="row">
                            <div class="col-md-12 mb-5">
                                <b-nav tabs>
                                    <b-nav-item @click="routerGoTo('transactions')" >{{$t('text.apmPages.transactionsLabel')}}</b-nav-item>
                                    <b-nav-item @click="routerGoTo('errors')" active>{{$t('text.apmPages.errors')}}</b-nav-item>
                                    <b-nav-item @click="routerGoTo('metrics')" >{{$t('text.apmPages.metrics')}}</b-nav-item>
                                </b-nav>
                            </div>
                        </div>


                        <h3 class="mb-5">
                            {{$t('text.apmPages.apmErrorGroup.errorGroup')}} {{$route.params.errorGroup.substr(0,5)}}
                        </h3>

                        <small class="text-muted">{{$t('text.apmPages.apmErrorGroup.exceptionMessage')}}</small>
                        <pre style="font-size: 1.1rem" class="mb-1">{{errorData.error.error.exception[0].message.replace('\n','.')}}</pre>
                        <small class="text-muted">{{$t('text.apmPages.apmErrorGroup.culprit')}}</small>
                        <pre style="font-size: 1.1rem" class="mb-5">{{errorData.error.error.exception[0].culprit ? errorData.error.error.exception[0].culprit : 'N/A'}}</pre>

                        <div class="row mt-3 mb-3">

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="startTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="DD.MM.YYYY, HH:mm"
                                                      v-model="startTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="endTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="DD.MM.YYYY, HH:mm" v-model="endTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>
                        </div>


                        <div class="row mt-3" id="wrapper">

                            <div class="col-md-12">
                                <div id="chart-bar" class="mt-3">
                                    <label for="error-occurrences">{{$t('text.apmPages.errorOccurrences')}}</label>
                                    <apexchart id="error-occurrences" type="bar" height="300"
                                               :options="errorOccurrencesChartOptions"
                                               :series="errorOccurrencesChartSeries"
                                               :key="errorOccurrencesChartDataLoaded"/>
                                </div>
                            </div>
                        </div>


                        <div>

                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4>{{$t('text.apmPages.apmErrorGroup.errorOccurrence')}}</h4>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <small>{{$t('text.apmPages.apmErrorGroup.timestamp')}}</small>
                                            <div class="font-weight-bolder">
                                                {{moment(errorData.error['@timestamp']).fromNow()}} <span
                                                    class="text-muted font-weight-normal">({{moment(errorData.error['@timestamp']).format('D. MMMM YYYY, HH:MM:ss.SSS')}})</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <small>{{$t('text.apmPages.apmErrorGroup.url')}}</small>
                                            <div class="font-weight-bolder">{{errorData.error.url ?
                                                errorData.error.url.full : 'N/A'}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="spacer mt-3"></div>

                                    <div class="row">
                                        <div class="col-md-3">
                                            <small>{{$t('text.apmPages.apmErrorGroup.requestMethod')}}</small>
                                            <div class="font-weight-bolder">{{errorData.error.http ?
                                                errorData.error.http.request.method : 'N/A'}}
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <small>{{$t('text.apmPages.apmErrorGroup.handled')}}</small>
                                            <div class="font-weight-bolder">{{errorData.error.error.exception.handled ?
                                                errorData.error.error.exception.handled : 'undefined'}}
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <small>{{$t('text.apmPages.apmErrorGroup.transactionSampleId')}}</small>
                                            <div class="font-weight-bolder">{{errorData.error.transaction.id}}</div>
                                        </div>
                                        <div class="col-md-3">
                                            <small>{{$t('text.apmPages.apmErrorGroup.userId')}}</small>
                                            <div class="font-weight-bolder">{{errorData.error.user ?
                                                errorData.error.user.id : 'N/A'}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="spacer mt-3"></div>

                                    <div class="row">
                                        <div class="col-md-12 mb-5">

                                            <b-card no-body>

                                                <b-tabs card>
                                                    <b-tab b-tab :title="$t('text.apmPages.apmErrorGroup.exceptionStacktrace')" active>

                                                        <b-button v-b-toggle.collapse-1 variant="link"
                                                                  @click="exceptionStacktraceCollapse = !exceptionStacktraceCollapse">
                                                            <i v-if="exceptionStacktraceCollapse"
                                                               class="fa fa-ellipsis-h"></i><i
                                                                v-if="!exceptionStacktraceCollapse"
                                                                class="fa fa-ellipsis-v"></i> {{errorData.error.error.exception[0].stacktrace.length}} {{$t('text.apmPages.apmErrorGroup.libraryFrames')}}
                                                        </b-button>

                                                        <b-collapse v-model="exceptionStacktraceCollapse" class="mt-2">
                                                            <div v-for="(item, index) in errorData.error.error.exception[0].stacktrace"
                                                                 :key="index"
                                                                 class="pl-5 mb-2">
                                                                <pre class="d-inline">{{item.filename}}</pre>
                                                                <span class="text-muted pl-2 pr-2"> {{$t('text.apmPages.apmErrorGroup.in')}}</span>
                                                                <pre class="d-inline">{{item.function}}</pre>
                                                                <span class="text-muted pl-2 pr-2">{{$t('text.apmPages.apmErrorGroup.at')}}</span>
                                                                <pre class="d-inline">{{$t('text.apmPages.apmErrorGroup.line')}} {{item.line.number}}</pre>
                                                            </div>
                                                        </b-collapse>

                                                    </b-tab>
                                                    <b-tab b-tab  :title="$t('text.apmPages.apmErrorGroup.host')">

                                                        <table class="table">

                                                            <tbody>
                                                            <tr v-for="(item, key, index) in errorData.error.host"
                                                                :key="index">
                                                                <th style="width: 150px">{{ key }}</th>
                                                                <td>{{ item }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>

                                                    </b-tab>
                                                    <b-tab b-tab :title="$t('text.apmPages.apmErrorGroup.service')">

                                                        <table class="table">

                                                            <tbody>
                                                            <tr v-for="(item, key, index) in errorData.error.service"
                                                                :key="index">
                                                                <th style="width: 150px">{{ key }}</th>
                                                                <td>{{ item }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>

                                                    </b-tab>
                                                    <b-tab b-tab :title="$t('text.apmPages.apmErrorGroup.process')">

                                                        <table class="table">

                                                            <tbody>
                                                            <tr v-for="(item, key, index) in errorData.error.process"
                                                                :key="index">
                                                                <th style="width: 150px">{{ key }}</th>
                                                                <td>{{ item }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>

                                                    </b-tab>
                                                    <b-tab b-tab :title="$t('text.apmPages.apmErrorGroup.agent')">

                                                        <table class="table">

                                                            <tbody>
                                                            <tr v-for="(item, key, index) in errorData.error.agent"
                                                                :key="index">
                                                                <th style="width: 150px">{{ key }}</th>
                                                                <td>{{ item }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>

                                                    </b-tab>
                                                    <b-tab b-tab :title="$t('text.apmPages.apmErrorGroup.container')">

                                                        <table class="table">

                                                            <tbody>
                                                            <tr v-for="(item, key, index) in errorData.error.container"
                                                                :key="index">
                                                                <th style="width: 150px">{{ key }}</th>
                                                                <td>{{ item }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>

                                                    </b-tab>
                                                    <b-tab b-tab :title="$t('text.apmPages.apmErrorGroup.user')">

                                                        <table class="table" v-if="errorData.error.user">

                                                            <tbody>
                                                            <tr v-for="(item, key, index) in errorData.error.user"
                                                                :key="index">
                                                                <th style="width: 150px">{{ key }}</th>
                                                                <td>{{ item }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>

                                                        <div class="text-center" v-if="!errorData.error.user">
                                                            <em><i class="fa fa-exclamation-triangle"></i> {{$t('text.apmPages.apmErrorGroup.noData')}}</em>
                                                        </div>

                                                    </b-tab>
                                                    <b-tab b-tab :title="$t('text.apmPages.apmErrorGroup.labels')">

                                                        <table class="table" v-if="errorData.error.labels">

                                                            <tbody>
                                                            <tr v-for="(item, key, index) in errorData.error.labels"
                                                                :key="index">
                                                                <th style="width: 150px">{{ key }}</th>
                                                                <td>{{ item }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>

                                                        <div class="text-center" v-if="!errorData.error.labels">
                                                            <em><i class="fa fa-exclamation-triangle"></i> {{$t('text.apmPages.apmErrorGroup.noData')}}</em>
                                                        </div>

                                                    </b-tab>
                                                </b-tabs>

                                            </b-card>

                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>

                    </div>


                </div>


            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import {VueGoodTable} from 'vue-good-table';
    import axios from 'axios/index';

    library.add(faHome);


    export default {
        name: 'Transactions',
        components: {
            SidebarNavigation
        },
        data() {
            return {
                startTimestamp: null,
                endTimestamp: null,
                startTimeDate: null,
                endTimeDate: null,
                errorOccurrencesChartDataLoaded: false,
                errorOccurrencesChartSeries: [{
                    name: '',
                    data: []
                }],
                errorOccurrencesChartOptions: {
                    colors: ['#80bcd2'],
                    plotOptions: {
                        bar: {
                            vertical: true,
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        id: 'errorOccurrences'
                    },
                    xaxis: {
                        type: "datetime",
                        categories: []
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return value + " occ.";
                            }
                        }
                    },
                    stroke: {
                        width: 1
                    }
                },
                errorData: [],
                breadcrumbItems: [
                    {
                        text: this.$t('text.apmPages.apmLabel'),
                        href: '#/apm'
                    },
                    {
                        text: this.$route.params.serviceName,
                        href: '#/transactions/' + encodeURIComponent(this.$route.params.serviceName)
                    },
                    {
                        text: this.$t('text.apmPages.errors'),
                        href: '#/errors/' + encodeURIComponent(this.$route.params.serviceName)
                    },
                    {
                        text: this.$route.params.errorGroup,
                        href: '#/errors/' + encodeURIComponent(this.$route.params.serviceName) + '/' + encodeURIComponent(this.$route.params.errorGroup),
                        active: true
                    }
                ],
                exceptionStacktraceCollapse: false
            }
        },



        mounted() {
            this.initDate();
        },


        watch: {
            '$route'(to, from) {
                // react to route changes...

                this.initDate();


            }

        },

        methods: {

            updateTimes(){

                this.$router.push({
                    path: "",
                    query:{
                        start: encodeURIComponent(this.startTimestamp),
                        end: encodeURIComponent(this.endTimestamp)
                    }
                });


            },

            routerGoTo(where){

                this.$router.push("/" + where + "/"+ this.$route.params.serviceName + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp));

            },

            getData() {
                const _this = this;

                this.errorOccurrencesChartDataLoaded = false;


                console.log("cas zacetka: ", this.startTimestamp);
                console.log("cas konca: ", this.endTimestamp);

                axios.get(config.kibana + this.$route.params.serviceName + "/errors/distribution/" + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&groupId=" +  this.$route.params.errorGroup + "&uiFilters=%7B%7D", {headers: {}})
                    .then((res) => {

                        // errors graf
                        console.log("response za transaction duration graf:", _.map(res.data.buckets, 'count'));

                        _this.errorOccurrencesChartSeries[0] = {
                            name: "test",
                            data: _.map(res.data.buckets, 'count')
                        };

                        for (let i = 0; i < res.data.buckets.length; i++) {
                            _this.errorOccurrencesChartOptions.xaxis.categories[i] = res.data.buckets[i].key;
                        }

                        _this.errorOccurrencesChartDataLoaded = true;
                        console.log("errorOccurrencesChartDataLoaded", _this.errorOccurrencesChartDataLoaded);
                        console.log("_this.errorOccurrencesChartOptions", _this.errorOccurrencesChartOptions);

                    })
                    .catch((error) => {
                        console.log(error);
                    });


                //tabela
                axios.get(config.kibana + this.$route.params.serviceName + "/errors/" + this.$route.params.errorGroup + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&uiFilters=%7B%7D", {headers: {}})
                    .then((res) => {
                        console.log("response za tabelo:", res.data);
                        this.errorData = res.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    });

            },

            initDate() {

                if (this.$route.query.start == null && this.$route.query.end == null) {
                    this.endTimeDate = new Date();
                    this.startTimeDate = new Date();
                    this.startTimeDate.setDate(this.endTimeDate.getDate() - 1);
                    this.startTimestamp = this.startTimeDate.toISOString();
                    this.endTimestamp = this.endTimeDate.toISOString();

                    this.$router.push({
                        path: "",
                        query:{
                            start: encodeURIComponent(this.startTimestamp),
                            end: encodeURIComponent(this.endTimestamp)
                        }
                    });

                } else {

                    this.startTimestamp = decodeURIComponent(this.$route.query.start);
                    this.endTimestamp = decodeURIComponent(this.$route.query.end);


                }

                this.breadcrumbItems[0].href = "#/apm/" + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.breadcrumbItems[1].href = "#/transactions/" + encodeURIComponent(this.$route.params.serviceName) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.breadcrumbItems[2].href = "#/errors/" + encodeURIComponent(this.$route.params.serviceName) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.getData();
            },


            formatMiliseconds(value) {
                return Math.round(value / 1000) + " " + this.$t('text.apmPages.ms')
            },

            formatTransactionsPerMinute(value) {
                return +parseFloat(value).toFixed(1) + " " + this.$t('text.apmPages.tpm')
            },

            onCellClick(params) {
                console.log(params);
                let transactionGroup = params.formattedRow.name;

                this.$router.push('/transactions/' + this.$route.params.serviceName + '/' + encodeURIComponent(transactionGroup));
            }

        },
        beforeCreate: function () {
            document.body.className = 'transactions';
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/ApmErrorGroup.vue